import { css } from "styled-components";
import { spacing8, blue10, info10, info40, text120, white } from "@churchofjesuschrist/eden-style-constants";
const shared = css(["color:", ";& > :first-child{margin-block-start:0;}& > :last-child{margin-block-end:0;}& > :first-child > :first-child{margin-block-start:0;}& > :last-child > :last-child{margin-block-end:0;}& ol,& ul{& li:not(:last-child){margin-block-end:", ";}}& ol{list-style-type:decimal;& ol{list-style-type:upper-latin;& ol{list-style-type:upper-roman;& ol{list-style-type:lower-latin;}}}}& ul{list-style-type:disc;& ul{list-style-type:circle;& ul{list-style-type:square;}}}& a{color:", ";text-decoration:underline;}& a:hover{color:", ";text-decoration-color:", ";}"], _ref => {
  let {
    inverted
  } = _ref;
  return inverted ? white : text120;
}, spacing8, _ref2 => {
  let {
    inverted
  } = _ref2;
  return inverted ? blue10 : info40;
}, _ref3 => {
  let {
    inverted
  } = _ref3;
  return inverted ? white : text120;
}, _ref4 => {
  let {
    inverted
  } = _ref4;
  return inverted ? blue10 : info10;
});
export default shared;